<template>
  <LSection>
    <template #body>
      <div class="flex flex-col items-center justify-center mb-16">
        <div class="w-full">
          <TabNavigation :tabs="tabs" />
          <div class="body relative mb-12">
            <router-view name="impactTab"></router-view>
          </div>
        </div>
      </div>
    </template>
  </LSection>
</template>

<script>
import { ref } from "vue";
import LSection from "@/components/layout/LSection.vue";
import TabNavigation from "@/components/TabNavigation.vue";

export default {
  name: "QuantumHRWorkflowAssistantTabs",
  components: { LSection, TabNavigation },
  setup() {
    const tabs = ref([
      {
        name: "About Quantum HR Workflow Assistant",
        to: { name: "aboutQuantumHRWorkflowAssistant" },
        routeName: "aboutQuantumHRWorkflowAssistant",
      },
      {
        name: "Try the assistant",
        to: { name: "quantumHRWorkflowAssistantTab" },
        routeName: "quantumHRWorkflowAssistantTab",
      },
    ]);

    return {
      tabs,
    };
  },
};
</script>
